/**
 * 功能：店铺数据统计
 * 下单数 orderNum
 * 支付订单数 payOrderNum
 * 下单重量(吨) orderWeigth
 * 下单金额(元) orderAmount
 */
export default function splitList(list) {
  const orderNum = []
  const payOrderNum = []
  const orderWeight = []
  const orderAmount = []
  list.sort((a, b) => (a.dt > b.dt ? 1 : -1))
  list.forEach(item => {
    const { orderCnt, payCnt, totalWeight, actualTotalFee } = item
    const dt = item.dt.substring(5)
    orderNum.push({ dt, value: orderCnt })
    payOrderNum.push({ dt, value: payCnt })
    orderWeight.push({ dt, value: parseFloat(totalWeight.toFixed(4)) })
    orderAmount.push({ dt, value: parseFloat(actualTotalFee.toFixed(2)) })
  })
  return { orderNum, payOrderNum, orderWeight, orderAmount }
}
